<template>
  <nav-bar :back="goBack" :title="dMess.departName" />
  <layout-sale :top="0" :role="1">
    <Loading
      v-if="showLoading"
      :isLoading="isLoading"
      @reload="getDataLoading"
    />
    <div class="department">
      <van-icon name="wap-home-o" />
      <span>{{ dMess.groupName }} </span>
    </div>
    <van-cell-group title="员工情况">
      <van-cell v-for="item in eList" :key="item.id" :title="item.title" />
    </van-cell-group>
  </layout-sale>
</template>

<script>
import { ref, reactive, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { getAgentMesslist } from '@/api/agentMess'
import { getSaleEmpData } from '@/api/saleEmp'
import { useGetDataLoading } from '@/hooks/useGetDataLoading'
export default {
  name: 'SaleEmp', // 员工列表
  props: [],
  setup(prop) {
    const dMess = ref({})
    const eList = ref([])
    const loading = ref(false)
    const finished = ref(false)
    const store = useStore()
    const router = useRouter()
    const departId = computed(() => store.state.roleInfo.departId)
    // 获取公司信息
    const getAgentMess = async () => {
      const { status, data } = await getAgentMesslist(departId.value)
      if (status === 200) {
        dMess.value = data
      }
    }
    const pa = reactive({
      deptId: departId.value
    })
    const { getDataLoading, showLoading, isLoading } = useGetDataLoading(
      getSaleEmpData,
      data => {
        eList.value = data.children[0].children
      },
      pa
    )
    const goBack = () => {
      router.push('/salesUserHome')
    }
    getAgentMess()
    getDataLoading()
    return {
      getDataLoading,
      isLoading,
      showLoading,
      loading,
      finished,
      eList,
      dMess,
      getAgentMess,
      pa,
      goBack
    }
  }
}
</script>

<style lang="scss" scoped>
.form {
  margin-bottom: 16px;
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
.department {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  padding: 16px;
}
</style>
